import ImgTiNau from "../assets/img/ti-nau.png";
import ImgOSen from "../assets/img/o-sen.png";
import ImgLadyMay from "../assets/img/lady.png";
import ImgPhuongHoangLua from "../assets/img/phuong.png";

export const TIME_START = 1724515200000;

export const STATUS_CAMPAIGN = {
  NOT_STARTED: 0,
  RUNNING: 1,
  ENDED: 2,
};

export const AVATAR_SINGER = {
  "tms2022-tinau": ImgTiNau,
  "tms2022-osen": ImgOSen,
  "tms2022-ladymay": ImgLadyMay,
  "tms2022-phuonghoanglua": ImgPhuongHoangLua,
};

export const NAME_SINGER = {
  "tms2022-tinau": "Tí Nâu",
  "tms2022-osen": "O Sen",
  "tms2022-ladymay": "Lady Mây",
  "tms2022-phuonghoanglua": "Phượng Hoàng Lửa",
};

export const POPUP_NAME = {
  LOGIN: "LOGIN",
  LOGOUT: "LOGOUT",
  FORGOT_PASSWORD: "FORGOT_PASSWORD",
  REGISTRATION: "REGISTRATION",
  OTP_FORGET_PASSWORD: "OTP_FORGET_PASSWORD",
  OTP_REGISTRATION: "OTP_REGISTRATION",
  INFO_RULE: "INFO_RULE",
  USER_VOTING: "USER_VOTING",
  NOTIFY: "NOTIFY",
  SHOW_NOT_STARTED: "SHOW_NOT_STARTED",
  SHOW_ENDED: "SHOW_ENDED",
  NO_TURN_VOTING: "NO_TURN_VOTING",
  INTRO_ADS: "INTRO_ADS",
};

export const MSG = {
  ERROR:
    "Vì tính an toàn và bảo mật, xin bạn vui lòng đăng xuất và đăng nhập lại.",
  "campaign not started":
    'Bình chọn cho Chung kết Anh Trai Say Hi 2024 chưa bắt đầu. Mời bạn quay lại sau!',
  "campaign ended":
    "Thời gian bình chọn đã kết thúc, cảm ơn bạn đã đồng hành cùng Anh Trai Say Hi 2024!",
  ENDED:
    "Thời gian bình chọn đã kết thúc, cảm ơn bạn đã đồng hành cùng Anh Trai Say Hi 2024!",
  NOT_STARTED:
    'Bình chọn cho Chung kết Anh Trai Say Hi 2024 sẽ bắt đầu lúc {{TIME_START}}. Mời bạn quay lại sau!',
};
